import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = flag => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState(false);

  const addDeviceRef = useRef(null);
  const downloadHashRef = useRef(null);
  const deleteDeviceRef = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Страница оффлайн-устройств',
      description:
        'Добро пожаловать в раздел Оффлайн устройства — здесь вы управляете регистрацией и учётом устройств, которые подключаются к серверу без доступа в интернет. Удобно для работы в полевых и изолированных условиях.',
      target: null,
    },
    {
      title: 'Добавление оффлайн-устройства',
      description: (
        <>
          <div>Зарегистрируйте новое устройство в системе — всего пара шагов, и устройство будет готово к работе.</div>
          {!allowNextStep && (
            <Alert
              message={'Для продолжения просмотра инструкции зарегистрируйте нового пользователя.'}
              style={{ marginTop: '10px' }}
            />
          )}
        </>
      ),
      target: () => addDeviceRef.current,
    },
    {
      title: 'Таблица оффлайн-устройств',
      description: 'В таблице отображаются все зарегистрированные оффлайн-устройства с данными о владельце.',
      target: null,
    },
    {
      title: 'Скачивание хэша',
      description:
        'Скачайте регистрационный хэш — текстовый файл, который используется для загрузки на устройство при оффлайн-активации.',
      target: () => downloadHashRef.current,
    },
    {
      title: 'Удаление устройств',
      description: 'Удалите устройство из списка, если оно больше не актуально.',
      target: () => deleteDeviceRef.current,
    },
    {
      title: 'Поиск',
      description: 'Используйте поиск по ID или позывному для удобной навигации.',
      target: () => searchRef.current,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (nextStep === 2 && !allowNextStep) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    isTourOpen,
    currentStep,
    handleClose,
    steps,
    startTour,
    handleTourChange,
    setAllowNextStep,
    addDeviceRef,
    downloadHashRef,
    deleteDeviceRef,
    searchRef,
  };
};
